//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Item from "./Item.vue";

export default {
  name: "BluePagination",
  components: { Item },
  data() {
    return {
      hideCount: 0,
      adjusting: false,
      debounceTimer: null
    };
  },
  computed: {
    reloading() {
      return this.$store.getters.reloading;
    },
    isAdjusting() {
      if (!this.options.transitionOnReload && this.options.preserveResults) return false;
      else return this.adjusting;
    },
    totalPages() {
      return this.$store.getters.results.totalPages;
    },
    currentPage() {
      return this.$store.getters.currentPage;
    },
    enablePrev() {
      return this.currentPage > 0;
    },
    enableNext() {
      return this.currentPage < this.totalPages - 1;
    },
  },
  methods: {
    initializeHistory() {
      window.history.replaceState({ page: this.currentPage }, "");
      window.onpopstate = (e) => {
        this.$store.dispatch("goToPage", e.state.page);
      };
    },
    goToPage(index) {
      if (this.options.paginationUsesHistory) {
        window.history.pushState({ page: index }, "");
      }
      this.$store.dispatch("goToPage", index);
    },
    navigate(delta) {
      this.goToPage(this.currentPage + delta);
    },
    isActive(index) {
      return index === this.currentPage;
    },
    isNumber(index) {
      return this.getVisibilityAtIndex(index);
    },
    isEllipsis(index) {
      return this.getVisibilityAtIndex(index - 1);
    },
    async hideOverflow() {
      if (!this.$refs.root || !this.$refs.container) {
        this.adjusting = false;
        return;
      }

      let rootWidth = this.$refs.root.offsetWidth;
      let containerWidth = this.$refs.container.offsetWidth;

      while (
        rootWidth < containerWidth &&
        this.hideCount < this.totalPages - 5
      ) {
        this.hideCount++;
        await this.$nextTick();
        rootWidth = this.$refs.root.offsetWidth;
        containerWidth = this.$refs.container.offsetWidth;
      }

      applyMax: if (this.options.maxPaginationItems) {
        if (this.totalPages <= this.options.maxPaginationItems) break applyMax;
        if (this.totalPages - this.hideCount <= this.options.maxPaginationItems) break applyMax;
        this.hideCount = this.totalPages - this.options.maxPaginationItems;
      }
      this.adjusting = false;
    },
    getVisibilityAtIndex(index) {
      let visible = true;
      if (this.hideCount > 0) {
        const delta = Math.floor(this.hideCount / 2);

        if (
          index == 0 ||
          index == this.currentPage ||
          index == this.totalPages - 1
        ) {
          return visible;
        }

        let middle = Math.floor(this.totalPages / 2);
        let leftStart = middle;
        let lowRange = middle - delta;

        let rightStart = middle;
        let highRange = middle + delta;
        let rangeOffset = 0;

        if (
          this.currentPage >= lowRange - 2 &&
          this.currentPage <= highRange + 2
        ) {
          middle = this.currentPage;
          leftStart = middle - 2;
          lowRange = leftStart - delta;

          rightStart = middle + 2;
          highRange = rightStart + delta;
        }

        if (highRange > this.totalPages)
          rangeOffset = this.totalPages - highRange;
        if (lowRange < 1) rangeOffset = Math.abs(1 - lowRange);

        lowRange = lowRange + rangeOffset;
        highRange = highRange + rangeOffset;

        if (index <= leftStart && index >= lowRange) visible = false;
        if (index >= rightStart && index <= highRange) visible = false;
      }
      return visible;
    },
    async adjustAfterReload() {
      this.hideCount = 0;
      if (this.reloading) this.adjusting = true;
      await this.$nextTick();
      if (!this.reloading) {
        this.hideOverflow();
      }
    },
    adjustAfterResize() {
      clearTimeout(this.debounceTimer);
      this.adjusting = true;
      this.debounceTimer = setTimeout(async () => {
        this.hideCount = 0;
        await this.$nextTick();
        this.hideOverflow();
      }, 250);
    },
  },
  watch: {
    reloading() {
      this.adjustAfterReload();
    },
  },
  mounted() {
    if (this.options.paginationUsesHistory) this.initializeHistory();
    this.hideOverflow();
    window.addEventListener("resize", this.adjustAfterResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustAfterResize);
  },
};
